import { MimeType } from './types'

export const PREVIEW_WIDTH = 120
export const PREVIEW_HEIGHT = 120
export const ACCEPTED_MIME_TYPES = `${MimeType.JPG}, ${MimeType.PNG}, ${MimeType.PDF}`
